export default "__VITE_ASSET__KngbWhov__"